<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    function addHotelsPageLink(items) {
        const cityName = hotelsRuntimeStore.city?.name ? hotelsRuntimeStore.city.name : ''
        const countryName = hotelsRuntimeStore.city?.countryName || hotelsRuntimeStore.country?.name

        items.push({
            title: cityName ? `${cityName}, ${countryName}` : countryName,
            to: hotelsRuntimeStore.hotelsPageLink(this.searchRequest),
            link: true,
            exact: true,
        })
    }

    function addHotelPageLink(items) {
        items.push({
            title: this.offer.name,
            to: hotelsRuntimeStore.hotelPageLink(this.offer, this.searchRequest),
            link: true,
            exact: true,
        })
    }

    @Component({mixins: [Breadcrumbs]})
    export class HotelBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) offer

        get items() {
            const name = useRoute().name
            const items = [this.homeItem]

            switch (name) {
                case 'hotels':
                    items.push({
                        title: this.cityName ? `${this.cityName}, ${this.countryName}` : this.countryName,
                        disabled: true,
                    })
                    break
                case 'comparison':
                    addHotelsPageLink.call(this, items)
                    items.push({
                        title: this.$t('compare_hotels'),
                        disabled: true,
                    })
                    break
                case 'hotel':
                    addHotelsPageLink.call(this, items)
                    items.push({
                        title: hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo.hotelName,
                        disabled: true,
                    })
                    break
                case 'hotelBooking':
                    addHotelsPageLink.call(this, items)
                    addHotelPageLink.call(this, items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'hotelsConfirmation':
                    addHotelsPageLink.call(this, items)
                    addHotelPageLink.call(this, items)
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }

        get cityName() {
            return hotelsRuntimeStore.city?.name ? hotelsRuntimeStore.city.name : ''
        }

        get countryName() {
            return hotelsRuntimeStore.city?.countryName || hotelsRuntimeStore.country?.name
        }
    }

    export default {...toNative(HotelBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
